// extracted by mini-css-extract-plugin
export default {"wrapper":"wq-z","response":"xq-z","error":"yq-z","disabled":"zq-z","buttons":"Aq-z","feedbackQuestionSection":"Bq-z","yesNoWrapper":"Cq-z"};